module.exports = __webpack_public_path__ + "img/Flag_of_South_Korea.52f73c97.svg";